/**
 * @copyright 汽车商贸管理平台 V1.0
 * @year 2026
 * @file index.js
 */
import Vue from "vue";
import Vuex from "vuex";
import jwtDecode from "jwt-decode";

Vue.use(Vuex);

// 初始化时从存储中恢复 token
function getStoredToken() {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
}

export default new Vuex.Store({
  state: {
    token: getStoredToken(),
  },
  getters: {
    getToken(state) {
      return state.token;
    },
  },
  mutations: {
    LOGIN_IN(state, token) {
      state.token = token;
      // 由 Login.vue 决定存储到 localStorage 还是 sessionStorage
      localStorage.setItem("token", token);

      try {
        const decoded = jwtDecode(token);
        const userInfo = {
          user: decoded.username || "",
          unit: decoded.unit_name || "",
        };
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      } catch (error) {
        console.error("Token 解析失败:", error);
      }
    },
    LOGIN_OUT(state) {
      state.token = null;
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("userInfo");
    },
  },
  actions: {},
  modules: {},
});
